var _defs, _circle, _circle2, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomatoSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5019;}.cls-2{fill:#ff774c;}.cls-3{fill:#ff8b66;}.cls-4{fill:#ffd28f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tomato") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 12.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.72,17.72c-.12,3.83-3.33,3.83-3.45,0-3.83-.12-3.83-3.33,0-3.45.12-3.83,3.33-3.83,3.45,0C21.56,14.4,21.56,17.6,17.72,17.72Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.41 7.01 24.99 5.59 16 14.59 7.01 5.59 5.59 7.01 14.59 16 5.59 24.99 7.01 26.41 16 17.41 24.99 26.41 26.41 24.99 17.41 16 26.41 7.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,7.62a.5.5,0,0,1-.5-.5V5.5a.5.5,0,0,1,1,0V7.12A.5.5,0,0,1,16,7.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.76,9a.5.5,0,0,1-.42-.77l.74-1.14a.5.5,0,0,1,.84.54l-.74,1.14A.5.5,0,0,1,18.76,9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.24,9a.5.5,0,0,1-.42-.23l-.74-1.14a.5.5,0,0,1,.84-.54l.74,1.14a.5.5,0,0,1-.42.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,27a.5.5,0,0,1-.5-.5V24.88a.5.5,0,0,1,1,0V26.5A.5.5,0,0,1,16,27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.5,25.14a.5.5,0,0,1-.42-.23l-.74-1.14a.5.5,0,1,1,.84-.54l.74,1.14a.5.5,0,0,1-.42.77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.5,25.14a.5.5,0,0,1-.42-.77l.74-1.14a.5.5,0,1,1,.84.54l-.74,1.14A.5.5,0,0,1,12.5,25.14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.12,16.5H5.5a.5.5,0,0,1,0-1H7.12a.5.5,0,1,1,0,1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.5,13.74a.5.5,0,0,1-.27-.08l-1.14-.74a.5.5,0,0,1,.54-.84l1.14.74a.5.5,0,0,1-.27.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.36,20a.5.5,0,0,1-.27-.92l1.14-.74a.5.5,0,1,1,.54.84l-1.14.74A.5.5,0,0,1,7.36,20Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.5,16.5H24.88a.5.5,0,0,1,0-1H26.5a.5.5,0,0,1,0,1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.5,13.74a.5.5,0,0,1-.27-.92l1.14-.74a.5.5,0,1,1,.54.84l-1.14.74A.5.5,0,0,1,23.5,13.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.64,20a.5.5,0,0,1-.27-.08l-1.14-.74a.5.5,0,1,1,.54-.84l1.14.74a.5.5,0,0,1-.27.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomatoSlice);
export default __webpack_public_path__ + "static/media/tomatoSlice.7738459e751c7d9b4978fbc55cd8eb67.svg";
export { ForwardRef as ReactComponent };